import * as moment from 'moment';
import React, { Component } from 'react';

import Button from 'react-bootstrap/Button';

import styles from './Feedback.module.css';

import headerImage from './../images/modules/feedback.jpg';

import { CPLBanner } from '../../../components/Banner';
import { LanguageContext } from '../../../i18n/LanguageContext';

import { FeedbackService } from '../../../services/ApiService';

export default class FeedbackModule extends Component {
    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            search: '',
            showEditor: false,
            feedbacks: [],
            feedback: null
        }
    }

    onSearch = (search) => {
        this.setState({ search });
    }

    onCloseEditor = () => {
        this.setState({ showEditor: false, feedback: null });
    }

    getData = () => {
        FeedbackService.get()
            .then(feedbacks => this.setState({ feedbacks }))
            .catch(e => console.error(e));
    }

    componentDidMount() {
        this.getData();
    }

    onRowClicked = (data) => {
        this.setState({ showEditor: false });
        setTimeout(() => {
            this.setState({ showEditor: true, feedback: data });
        }, 0);
    }

    filterFeedbacks(search, feedback, properties) {
        for (let prop of properties) {
            if (RegExp(`(.)*${search}(.)*`, 'i').test(feedback[prop])) {
                return true;
            }
        }
        return false;
    }

    render() {
        let feedbacks = this.state.feedbacks.map(feedback => {
            feedback.createdAtDisplay = moment(feedback.createdAt).format('YYYY-MM-DD hh:mm A')

            switch (feedback.type) {
                case 'feedback':
                    feedback.typeName = this.context['FEEDBACK_TYPE_FEEDBACK'];
                    break;
                case 'complaint':
                    feedback.typeName = this.context['FEEDBACK_TYPE_COMPLAINT'];
                    break;
                case 'congratulations':
                    feedback.typeName = this.context['FEEDBACK_TYPE_CONGRATULATIONS'];
                    break;
                default:
                    feedback.typeName = '';
            }
            return feedback;
        });

        if (!!this.state.search) {
            feedbacks = feedbacks
                .filter(feedback => this.filterFeedbacks(this.state.search, feedback, [
                    'subject', 'typeName', 'createdAtDisplay'
                ]));
        }

        return <div className="col-md-12">
            <div className="row banner-wrapper">
                <div className="col-md-12">
                    <CPLBanner
                        img={headerImage}
                        content={this.context['FEEDBACK_ADMIN_MODULE_NAME']} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-7 col-md-7">
                    <FeedbackAdmin
                        feedbacks={feedbacks}
                        onRowClicked={this.onRowClicked}
                        onSearch={this.onSearch} />
                </div>
                <div className="col-lg-5 col-md-5">
                    {!!this.state.showEditor ? <Editor
                        onSave={this.onSave}
                        onClose={this.onCloseEditor}
                        feedback={this.state.feedback}
                    /> : null}
                </div>
            </div>
        </div>
    }
}

class FeedbackAdmin extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            search: ''
        };
    }

    onSearchListener = (evt) => {
        this.props.onSearch(evt.target.value);
        this.setState({ search: evt.target.value });
    }

    render() {
        return <div>
            <div className="card">
                <div className="card-header">
                    {this.context['FEEDBACKS']}
                    <span className="float-right">
                        <div className={styles['search-form']}>
                            <input type="text" value={this.state.search} onChange={this.onSearchListener} placeholder={`${this.context['SEARCH']}...`} />
                        </div>
                    </span>
                </div>
                <div className="card-body">
                    <table className="table table-borderless table-hover">
                        <thead>
                            <tr>
                                <th>{this.context['FEEDBACK_SUBJECT_TITLE']} ({this.props.feedbacks.length})</th>
                                <th>{this.context['FEEDBACK_TYPE_TITLE']}</th>
                                <th>{this.context['FEEDBACK_EMAIL_TITLE']}</th>
                                <th>{this.context['FEEDBACK_DATE_TITLE']}</th>
                            </tr>
                        </thead>
                        <ListItems
                            lang={this.context}
                            onRowClicked={this.props.onRowClicked}
                            feedbacks={this.props.feedbacks} />
                    </table>
                </div>
            </div>
        </div>
    }
}

const ListItems = (props) => {
    return <tbody>
        {props.feedbacks.map((feedback, index) => {
            return <ListItem
                key={index}
                index={index}
                onRowClicked={props.onRowClicked}
                feedback={feedback} />
        })}
    </tbody>
}


const ListItem = (props) => {
    const feedback = props.feedback;

    return <tr className={styles['editor-row-clickable']} onClick={() => props.onRowClicked(feedback)}>
        <td>{feedback.subject}</td>
        <td>{feedback.typeName}</td>
        <td>{feedback.email}</td>
        <td>{feedback.createdAtDisplay}</td>
    </tr>
}

class Editor extends Component {

    static contextType = LanguageContext;

    render() {
        const feedback = this.props.feedback;

        const labelClassName = `col-md-4`;
        const labelValueClassName = `col-md-8`;

        let type;
        switch (feedback.type) {
            case 'feedback':
                type = this.context['FEEDBACK_TYPE_FEEDBACK'];
                break;
            case 'complaint':
                type = this.context['FEEDBACK_TYPE_COMPLAINT'];
                break;
            case 'congratulations':
                type = this.context['FEEDBACK_TYPE_CONGRATULATIONS'];
                break;
            default:
                type = '';
        }

        return <div className="card">
            <div className="card-header">
                <b>{this.context['FEEDBACK_SUBJECT_TITLE']}</b>: {feedback.subject}
            </div>
            <div className={`card-body ${styles['editor-rows']}`}>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['FEEDBACK_TYPE_TITLE']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={type} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['CONTENT']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <textarea class="form-control" rows="5" value={feedback.content} readOnly />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['EMAIL']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={feedback.email} readOnly />
                    </div>
                </div> 
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['PHONE']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={feedback.phone} readOnly />
                    </div>
                </div> 
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['NAME']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={!!feedback.name ? feedback.name : '-'} readOnly />
                    </div>
                </div> 
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['LAST_NAME']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={!!feedback.lastName ? feedback.lastName : '-'} readOnly />
                    </div>
                </div> 
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['FEEDBACK_DATE_TITLE']}</p>
                    </div>
                    <div className={labelValueClassName}>
                        <input className={styles['editor-form-control']} type="text" value={moment(feedback.createdAt).format('YYYY-MM-DD hh:mm A')} readOnly />
                    </div>
                </div> 
            </div>
            <div className="card-footer">
                <span className="float-right">
                    <Button variant="secondary" onClick={() => this.props.onClose()}>
                        {this.context['CLOSE']}
                    </Button>
                </span>
            </div>
        </div>
    }
}